import $ from 'jquery';
import { Tooltip } from 'foundation-sites';

const tooltipContainer = $('.help_infowindow');
const tooltipToggler = $('<span class="gform-helper">?</span>');

tooltipContainer.append( tooltipToggler );

const tooltipOptions = {
  position: 'bottom',
  alignment: 'center',
  tipText: 'Besoin d’aide ? Appelez-nous au : 08 2000 66 22',
  tooltipClass: 'tooltip tooltip--large'
};

const tooltipElem = new Tooltip(tooltipToggler, tooltipOptions);